import { render, staticRenderFns } from "./apply-refund-form.vue?vue&type=template&id=52246068&"
import script from "./apply-refund-form.vue?vue&type=script&lang=js&"
export * from "./apply-refund-form.vue?vue&type=script&lang=js&"
import style0 from "./apply-refund-form.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports